import { Stack, Typography } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";

function Khiladi_adda() {
  const vht = useSelector((state) => state.qwickSilver);
  return (
    <>
      <Stack spacing={2}>
        <Stack spacing={1} direction='row'>
          <Typography>Last Order Price</Typography>
          <Typography color='primary'> {vht?.data?.response?.last_ka_order_price || "--"}</Typography>
        </Stack>
        <Stack spacing={1} direction='row'>
          <Typography>Last Order Date</Typography>
          <Typography color='primary' >{vht?.data?.response?.last_ka_order_at || "--"}</Typography>
        </Stack>
      </Stack>
    </>
  );
}

export default Khiladi_adda;
